import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4ae089cf")

_pushScopeId("data-v-4ae089cf")
const _hoisted_1 = {
  key: 0,
  class: "pb-mobile-120"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "footer-space" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BusinessClientHeader = _resolveComponent("BusinessClientHeader")
  const _component_BusinessClientDetails = _resolveComponent("BusinessClientDetails")
  const _component_BusinessClientFooter = _resolveComponent("BusinessClientFooter")
  const _component_MobileFooterActions = _resolveComponent("MobileFooterActions")

  return (_ctx.loaded)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode(_component_BusinessClientHeader, {
          name: _ctx.businessClient.name,
          editMode: false,
          onBack: _ctx.back,
          onEdit: _ctx.edit,
          hideActionsOnMobile: true
        }, null, 8, ["name", "onBack", "onEdit"]),
        _createVNode("div", null, [
          _createVNode(_component_BusinessClientDetails, {
            editMode: false,
            businessClientProp: _ctx.businessClient,
            activeBtn: _ctx.activeBtn,
            onActiveBtn: _ctx.setActiveBtn
          }, null, 8, ["businessClientProp", "activeBtn", "onActiveBtn"])
        ]),
        _hoisted_2,
        _createVNode(_component_BusinessClientFooter, {
          amountOrder: _ctx.amountOrder,
          totalInvoices: _ctx.totalInvoices,
          totalAllReceipts: _ctx.totalAllReceipts,
          totalBindedReceipts: _ctx.totalBindedReceipts,
          totaInvoiceslLeftToBind: _ctx.totaInvoiceslLeftToBind,
          balance: _ctx.balance,
          activeBtn: _ctx.activeBtn,
          currencySign: _ctx.currencySign
        }, null, 8, ["amountOrder", "totalInvoices", "totalAllReceipts", "totalBindedReceipts", "totaInvoiceslLeftToBind", "balance", "activeBtn", "currencySign"]),
        _createVNode(_component_MobileFooterActions, {
          editMode: false,
          onBack: _ctx.back,
          onEdit: _ctx.edit
        }, null, 8, ["onBack", "onEdit"])
      ]))
    : _createCommentVNode("", true)
})